export const FILES_VISIBLE_COUNT_DEFAULT = 3
